import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const Overlay = styled.div`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background: gray;
  z-index: 10;
  opacity: 70%;
`;

export const LaunchModal = styled.div`
  width: 33rem;
  position: fixed;
  overflow: scroll;
  max-height: 75vh;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 1.5rem;
  z-index: 101;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  flex-direction: column;
  display: flex;
  align-items: center; 
  .buttons {
    display: flex;
    align-items: center;
    width: 70%;
    flex-direction: row;
    justify-content: space-evenly;
    z-index: 999999999999999;
    order: 9999999999;
  }
  .close_button {
    width: 90%;
    height: 5%;
    font-size: 2rem;
    margin-top: 2rem;
    i {
      float: right;
      cursor: pointer;
    }
  }
  @media(min-width: ${TABLET_WIDTH}px) {
    left: 50%;
    bottom: 50%;
    height: 40vh;
    width: 50rem;
  }
  iframe {
    height: 75vh;
    width: 100%;
  }
  .center_items {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 90%;
  }
`;

export const LaunchTitle = styled.div`
  margin-top: -2rem;
  font-size: 2.1rem;
  width: 80%;
  text-align: center;
`;

export const LaunchSubtitle = styled.div`
  margin-top: 1rem;
  font-size: 1.7rem;
  margin-bottom: 2rem;
  width: 80%;
  text-align: center;
`;

export const LaunchNextButton = styled.div`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.2rem;
  width: 7rem;
  padding: 0.8rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: ${props => (props.cont ? '#2680EB' : 'gray')};
  margin-bottom: 2rem;
`;

export const LaunchActionButton = styled.div`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.2rem;
  width: 7rem;
  padding: 0.8rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: ${props => props.color};
  margin-bottom: 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/Launch/components/styles.js